var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "featured-collection-slider" }, [
    _c("div", { ref: "collectionSwiper", staticClass: "swiper-container" }, [
      _c(
        "div",
        { staticClass: "swiper-wrapper" },
        _vm._l(_vm.data, function(product, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "swiper-slide",
              attrs: {
                "data-aos": "fade-up",
                "data-aos-duration": "400",
                "data-aos-delay": _vm.calcDelay(index)
              }
            },
            [_c("product-card", { attrs: { url: _vm.url, item: product } })],
            1
          )
        }),
        0
      )
    ]),
    _vm._v(" "),
    _c("div", { ref: "prev", staticClass: "swiper-button-prev" }),
    _vm._v(" "),
    _c("div", { ref: "next", staticClass: "swiper-button-next" }),
    _vm._v(" "),
    _c("div", { staticClass: "swiper-pagination" })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }